module.exports = __webpack_public_path__ + "img/fin-balance2.3b92d3a0.jpg";